import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HeroCarousel from '../Common/HeroCarousel';
import { FaArrowLeft } from 'react-icons/fa';
import image9 from '../../Assets/image 9.png';
import image10 from '../../Assets/image 10.png';
import image11 from '../../Assets/image 11.png';

const SupportGrowth = () => {
  const navigate = useNavigate();

  const ministryAreas = [
    {
      id: 1,
      title: 'Pastoral Care',
      description: 'Professional counseling, home and hospital visits, and emotional support during difficult seasons of life.',
      image: image9,
      programs: [
        'Marriage and family counseling.',
        'Home and Hospital Visitation.',
        'Crisis intervention services'
      ]
    },
    {
      id: 2,
      title: 'Discipleship Training',
      description: 'Systematic biblical training designed to help believers grow in spiritual maturity and ministry effectiveness',
      image: image10,
      programs: [
        'New member discipleship classes',
        'Leadership development program',
        'Ministry training workshops',
        'Biblical studies certification'
      ]
    },
    {
      id: 3,
      title: 'Small Groups',
      description: 'Intimate fellowship where people Bible study, prayer, accountability, and building meaningful relationships with other believers',
      image: image11,
      programs: [
        'Weekly home group meetings',
        'Men\'s and women\'s groups',
        'Topical study groups',
        'Support and recovery groups'
      ]
    }
  ];

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <HeroCarousel 
        title="Ministries"
        subtitle="Discover how you can grow, serve, and connect through our specialized ministries"
        height="h-[500px]"
        contentPosition="bottom"
      />

      {/* Back Button and Content Section */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          {/* Back Button */}
          <button 
            onClick={() => navigate('/ministries')}
            className="flex items-center gap-2 text-primary hover:text-blue-700 mb-8 font-sf-pro font-medium"
          >
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <FaArrowLeft className="text-white text-sm" />
            </div>
            Back
          </button>

          {/* Title and Description */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Support & Growth Ministries</h2>
            <p className="text-gray-700 text-lg max-w-3xl mx-auto font-sf-pro">
              Ministries focused on personal development, spiritual growth, and providing support during life's challenges and transitions.
            </p>
          </div>

          {/* Ministry Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {ministryAreas.map((area) => (
              <div key={area.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="relative h-48">
                  <img 
                    src={area.image} 
                    alt={area.title} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3">{area.title}</h3>
                  <p className="text-gray-600 text-sm font-sf-pro leading-relaxed mb-4">
                    {area.description}
                  </p>
                  <ul className="space-y-2">
                    {area.programs.map((program, index) => (
                      <li key={index} className="flex items-start gap-2 text-sm text-gray-700 font-sf-pro">
                        <span className="text-orange-500 mt-1">●</span>
                        <span>{program}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Button */}
          <div className="flex justify-center">
            <button 
              onClick={() => navigate('/ministries/join')}
              className="bg-black text-white px-8 py-3 rounded-lg font-medium hover:bg-gray-900 transition font-sf-pro"
            >
              Join us
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default SupportGrowth;
